<template>
  <app-layout>
    <template slot="endDrawerMenu">
      <v-list-tile @click="logout">
        <v-list-tile-action>
          <v-icon v-html="'mdi-close-outline'"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="caption font-weight-medium">
            {{ $t('Cerrar sesión') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <dashboard-layout>
      <template slot="header">
        <h1 class="pt-3">
          {{ $t('Mis datos de usuario') }}
        </h1>
        <aru-auto-form
          class="my-3"
          v-if="configLoaded"
          v-model="userData"
          :form-configuration="config.form"
          @submit="updateUser"
          :submit-button="true"
          :dismiss-button="false"
        ></aru-auto-form>
        <div v-else class="big-card-layout"></div>
        <v-snackbar
          v-model="notification.snackbar"
          :bottom="notification.y === 'bottom'"
          :color="notification.color"
          :left="notification.x === 'left'"
          :multi-line="notification.mode === 'multi-line'"
          :right="notification.x === 'right'"
          :timeout="notification.timeout"
          :top="notification.y === 'top'"
          :vertical="notification.mode === 'vertical'"
        >
          {{ notification.text }}

          <v-btn dark text @click="notification.snackbar = false">
            Cerrar
          </v-btn>
        </v-snackbar>
      </template>
      <template slot="footer-row">
        <!-- <v-form ref="form" v-model="valid" lazy-validation>
                    <aru-auto-group-field v-if="configLoaded" v-model="userData" :field-groups="config.form.groups"></aru-auto-group-field>
                </v-form> -->
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import ApiCtrl from '@/services/api/abstract/abstract-api.js';
import AruAutoForm from '@/components/commons/form/AruAutoForm';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
    AruAutoForm,
  },

  data() {
    return {
      configLoaded: false,
      config: {},
      userData: {
        name: this.$store.state.user.name,
        email: this.$store.state.user.email,
        password: '',
      },
      valid: true,
      notification: {
        color: '',
        mode: 'multi-line',
        snackbar: false,
        text: '',
        timeout: 6000,
        x: '',
        y: 'top',
      },
    };
  },
  mounted() {
    console.log({ store: this.$store.state.user.name });
    this.getConfig();
  },

  methods: {
    getConfig() {
      this.configLoaded = false;
      ApiCtrl.get('/config/user').then(res => {
        console.log({ config: res });
        this.config = res.data.data;
        this.configLoaded = true;
      });
    },
    logout: function() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
    _updateUser(data) {
      console.log(data);
      data._method = 'put';
      ApiCtrl.post('/user/' + this.$store.state.user.id, data).then(res => {
        console.log(res);
      });
    },
    updateUser(data) {
      console.log(data);
      data._method = 'put';

      let formData = new FormData();

      /*
        Add the form data we need to submit
      */
      for (const field in data) {
        if (data.hasOwnProperty(field)) {
          const value = data[field];
          if (value) {
            formData.append(field, value);
          }
        }
      }

      ApiCtrl.postUpload('/user/' + this.$store.state.user.id, formData).then(res => {
        console.log(res);
        this.notification.color = 'success';
        this.notification.text = 'Operación realizada con éxito';
        this.notification.snackbar = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.big-card-layout {
  min-height: 30vh;
}

.v-list {
  &__tile {
    &__action {
      min-width: 35px;
    }
  }
}
</style>
